<style src='style.scss'>

</style>
  <section class="mbsc-row">
    <div class="mbsc-col-12">
      <header>
        <h1>¡Bienvenido!</h1>
        <p class="mbsc-col-12 mbsc-col-lg-8">
          Utiliza tu correo electrónico y contraseña con los que te registraste para acceder a la plataforma.
        </p>
      </header>
    </div>
    <div class="mbsc-col-12 mbsc-offset-md-3 mbsc-col-md-6">
      <div class="mbsc-align-center form-messages">
        <div class="mbsc-note mbsc-note-success">{@html successMessage}</div>
        <div class="mbsc-note mbsc-note-danger">{@html dangerMessage}</div>
        <div class="mbsc-note mbsc-note-warning">{@html warningMessage}</div>
      </div>
      <form class="signin-form">
        <div class="mbsc-form-group">
          <div class="mbsc-form-group-title">Iniciar sesión</div>
          <label>
            <input mbsc-input name="email" id="email" type="email" placeholder="Correo electrónico" required data-icon="user4">
          </label>
          <label>
            <input mbsc-input name="password" id="password" type="password" placeholder="Password" minlength="8" required data-icon="lock2" data-password-toggle="true">
          </label>
        </div>
        <p>
          ¿Haz olvidado tu contraseña? Recuperala <a href="/recover/">aquí</a>
        </p>
        <div class="mbsc-form-group mbsc-btn-group-block">
          <button mbsc-button id="md-success" data-icon="checkmark" on:click={validateForm}>Acceder</button>
        </div>
      </form>
    </div>
    <Banner
      title='¿Por qué D-NS Studio?'
      description='<p>Porque nuestra forma de dar clases en líneas no la vas a encontrar en ningún otro lado. ¿Ya conoces nuestro <a href="/nuestro-reproductor/">reproductor de video</a>?</p><p>Porque no tienes que esperar y puedes tomar cualquier clase en cualquier momento y en cualquier lugar, solo necesitas tu smartphone o tu PC.</p>Porque con D-NS Studio puedes encontrar fácilmente no solo la clase, sino la sección dentro de la clase que te interese, olvídate de guardar archivos gigantes que vas a terminar borrando y regresa a ese paso cada vez que quieras cuando quieras.</p><p>Porque no tienes que pagar por clase, ni por disciplina y mientras más tiempo pase, más contenido tendrás disponible por el mismo precio.</p><p>Porque formarás parte de una comunidad con la que puedes interactuar, se preocupa por tí y te quiere ver feliz, desde antes, durante y después del distanciamiento social.</p><p>Porque sin importar si aún no estas listo para unirte a D-NS Studio, tenemos <a href="/clase-gratis/">clases gratis</a> para tí ¡y encuentres más razones por las que elegir D-NS Studio!.</p>'
      image='/images/4-clases.jpg'
    ></Banner>
  </section>

  <script>
  import { onMount, afterUpdate, beforeUpdate } from 'svelte';

  import Banner from '@Components/Banner/index.svelte';

  import { AWSAuth, Navigation } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let signupForm = null, addedToFields = false;

  let successMessage = '';
  let warningMessage = '';
  let dangerMessage = '';

  let validateForm = async (event) => {
    event.preventDefault();
    document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'none';
    document.querySelector('.mbsc-note.mbsc-note-warning').style.display = 'none';
    dangerMessage = '';
    let formvalid = true;

    for (let f = 0; f < signupForm.elements.length; f++) {
      let field = signupForm.elements[f],
      name = field.name.charAt(0).toUpperCase() + field.name.slice(1),
      parent = field.parentNode,
      errorMsg = parent.querySelector('.mbsc-err-msg');

      if (name && field.validity.valid) {
        parent.parentNode.classList.remove('mbsc-err');

        if (errorMsg) {
          parent.removeChild(errorMsg);
        }
      } else if (name) {
        if (!errorMsg) {
          errorMsg = document.createElement('span');
          errorMsg.className = 'mbsc-err-msg';
          parent.appendChild(errorMsg);
        }

        var firstError = null;
        for (var key in field.validity) {
          if (!firstError && key !== 'valid' && field.validity[key]) {
            firstError = key;
          }
        }
        switch (firstError) {
          case 'tooShort':
          {
            errorMsg.innerHTML = name + ' es incorrecto';
            break;
          }
          case 'valueMissing':
          default:
          {
            errorMsg.innerHTML = name + ' es requerido';
            break;
          }
        }
        parent.parentNode.classList.add('mbsc-err');
        formvalid = false;
      }
    }

    if (formvalid && (event.type === 'click')) {
      document.querySelector('#md-success').disabled = true;
      const email = document.querySelector('#email').value;
      const password = document.querySelector('#password').value;

      AWSAuth.signIn(email, password).then((response) => {
        if (response === undefined) {
          dangerMessage = 'Ocurrió un error al iniciar sesión.';
          document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
        } else if (typeof response.code === 'string'){
          if (DEBUG) console.log(response.code);
          if (response.code === 'NotAuthorizedException'){
            warningMessage = 'Nombre de usuario o password incorrectos.';
          } else if (response.code === 'UserNotConfirmedException'){
            warningMessage = `Hemos enviado un correo electrónico de verificación a ${email}, por favor revisa tu bandeja de entrada. <a href="javascript:window._sendVerificationCode('${email}');">¿Reenviar código?</a>`;
          } else if (response.code === 'UserNotFoundException'){
            warningMessage = `No hay ninguna cuenta registrada con ese correo, por favor <a href="/signup/">registrate</a> primero.`;
          } else {
            warningMessage = response.message;
          }
          document.querySelector('.mbsc-note.mbsc-note-warning').style.display = 'block';
          document.querySelector('#email').value = '';
          document.querySelector('#password').value = '';
        } else if (response.attributes) {
          Navigation.goTo('classes');
        }
        document.querySelector('#md-success').disabled = false;
      });
    } else if (!addedToFields) {
      addedToFields = true;
    } else if (!formvalid) {
      dangerMessage = 'Ocurrió un error al iniciar sesión.';
      document.querySelector('.mbsc-note.mbsc-note-danger').style.display = 'block';
    }
    return false;
  };

  afterUpdate(() => {
    mobiscroll.form('.signin-form', {});
  });

  onMount(async () =>{
    signupForm = document.querySelector('.signin-form');
    signupForm.noValidate = true;
  });
</script>
